export default {
  isControl: true,
}
